import { TimelineStore } from './timeline.store';
var TimelineComponent = /** @class */ (function () {
    function TimelineComponent(timelineStore) {
        this.timelineStore = timelineStore;
    }
    Object.defineProperty(TimelineComponent.prototype, "width", {
        get: function () {
            return this.timelineStore.width;
        },
        enumerable: true,
        configurable: true
    });
    return TimelineComponent;
}());
export { TimelineComponent };



// WEBPACK FOOTER //
// ./src/app/rec/timeline/timeline.component.ts.pre-build-optimizer.js